import { ProductVariant } from '@shared/lib/shopify/types';
import { JewelryVariant } from '@shared/lib/shopify/types/shopify-native';

export const withAddToCartTracking = <T extends (...args: any[]) => any>(
  originalAction: T,
  variants?: (ProductVariant | JewelryVariant)[],
  quantity?: number
) => {
  if (process.env.VERCEL_ENV !== 'production') {
    return originalAction;
  }

  return async (...args: Parameters<T>) => {
    // Track before the server action
    if (typeof window !== 'undefined') {
      try {
        const totalValue = variants?.reduce(
          (acc, variant) => acc + (parseFloat(variant.price.amount) || 0),
          0
        );
        // Google Ads conversion tracking
        (window as any).gtag?.('event', 'conversion', {
          send_to: 'AW-16921451189/kFL4CKijw6kaELW144Q_',
          value: totalValue || 50,
          currency: 'USD',
        });

        // GA4 ecommerce tracking
        (window as any).gtag?.('event', 'add_to_cart', {
          currency: 'USD',
          value: totalValue || 0,
          items:
            variants?.map((variant) => ({
              item_id: variant.id || '',
              item_name: variant.title || '',
              price: parseFloat(variant.price.amount) || 0,
              quantity: quantity || 1,
            })) || [],
        });
      } catch (error) {
        console.error('Error tracking add to cart conversion:', error);
      }
    }

    // Call the original form action
    return originalAction(...args);
  };
};

export const withSignupTracking = <T extends (...args: any[]) => any>(originalAction: T) => {
  if (process.env.VERCEL_ENV !== 'production') {
    return originalAction;
  }

  return async (...args: Parameters<T>) => {
    // Track before the server action
    if (typeof window !== 'undefined') {
      try {
        (window as any).gtag?.('event', 'conversion', {
          send_to: 'AW-16921451189/8aJ_CPK5-rkaELW144Q_',
          value: 50,
          currency: 'USD',
        });
      } catch (error) {
        console.error('Error tracking signup conversion:', error);
      }
    }

    return originalAction(...args);
  };
};
